import { Component, Input } from '@angular/core';

@Component({
	selector: 'quote-job-info',
	template: require('./quote-job-info.html'),
	styles: [require('./quote-job-info.scss')]
})
export class QuoteJobInfoComponent {
	@Input('job') job;
	@Input() fromQuoteView: boolean;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/quotes/common/quote-job-info/quote-job-info.ts